var map = {
	"./air-nga-en/assets/cup-icon.png": 43148,
	"./ais-tai-en/assets/cup-icon.png": 38727,
	"./ais-tai-tha/assets/cup-icon.png": 6523,
	"./demo-arabic/assets/cup-icon.png": 41651,
	"./demo-et-en/assets/cup-icon.png": 76200,
	"./demo-romanian/assets/cup-icon.png": 72194,
	"./demo-um-en/assets/cup-icon.png": 11155,
	"./dtac-tai-en/assets/cup-icon.png": 19906,
	"./dtac-tai-tha/assets/cup-icon.png": 77348,
	"./ethiotel-et-amh/assets/cup-icon.png": 61558,
	"./ethiotel-et-en/assets/cup-icon.png": 3261,
	"./mtn-cg-fr/assets/cup-icon.png": 9918,
	"./mtn-ci-fr/assets/cup-icon.png": 61300,
	"./mtn-cmr-fr/assets/cup-icon.png": 53872,
	"./mtn-gha-en/assets/cup-icon.png": 68965,
	"./mtn-nga-en/assets/cup-icon.png": 14113,
	"./mtn-zam-en/assets/cup-icon.png": 11187,
	"./saf-ke-en/assets/cup-icon.png": 52992,
	"./saudi-uae-en/assets/cup-icon.png": 10307,
	"./tlk-za-en/assets/cup-icon.png": 71660,
	"./vc-za-en/assets/cup-icon.png": 76784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98406;